import RibbonGallery from "./components/RibbonGallery";

export default function Home() {
  return (
    <div className="relative w-full bg-white text-neutral-900 font-sans">
      {/* ================= Hero (full viewport height) ================= */}
      <section
        id="home"
        className="relative z-10 flex w-full flex-col overflow-hidden"
        style={{ height: "100vh" }}
      >
        {/* Top Navigation */}
        <header className="relative z-20 border-b border-neutral-200 shrink-0">
          <div className="mx-auto flex items-center justify-between px-6 md:px-10 py-5">
            <div className="flex items-center gap-4">
              <div className="text-3xl font-serif italic leading-none">Dr</div>
              <div className="hidden sm:flex flex-col text-[11px] leading-tight text-neutral-500">
                <span>Created by</span>
                <span>D3adrabbit</span>
              </div>
            </div>

            <nav className="flex items-center gap-8 text-sm text-neutral-700">
              <a
                href="#home"
                className="hover:text-neutral-900 transition-colors whitespace-nowrap cursor-pointer"
              >
                Home
              </a>
              <a
                href="#about"
                className="hover:text-neutral-900 transition-colors whitespace-nowrap cursor-pointer"
              >
                About
              </a>
              <a
                href="#works"
                className="hover:text-neutral-900 transition-colors whitespace-nowrap cursor-pointer"
              >
                Works
              </a>
              <a
                href="#contact"
                className="hover:text-neutral-900 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact
              </a>
              <a
                href="#blog"
                className="hover:text-neutral-900 transition-colors whitespace-nowrap cursor-pointer relative"
              >
                Blog
                <sup className="ml-0.5 text-[10px] text-neutral-500">(2)</sup>
              </a>
            </nav>
          </div>
        </header>

        {/* Split Headline */}
        <div className="px-6 md:px-10 pt-8 md:pt-10 shrink-0">
          <div className="flex items-center justify-between gap-6 whitespace-nowrap">
            <h1 className="text-3xl md:text-5xl lg:text-6xl tracking-tight font-semibold leading-[1] whitespace-nowrap">
              VISUAL DESIGN
            </h1>
            <h1 className="text-3xl md:text-5xl lg:text-6xl tracking-tight font-semibold leading-[1] text-right whitespace-nowrap">
              AND INTERACTION
            </h1>
          </div>

          {/* Meta strip — small identifier labels under the headline */}
          <div className="mt-4 md:mt-5 flex items-center justify-between text-[10px] md:text-[11px] tracking-[0.35em] uppercase text-neutral-500">
            <div className="flex items-center gap-4 md:gap-6">
              <span className="flex items-center gap-2">
                <span className="inline-block h-1 w-1 rounded-full bg-neutral-900" />
                Index / 071
              </span>
              <span className="hidden md:inline text-neutral-400">
                Ribbon Gallery — Chapter 03
              </span>
            </div>

            <div className="hidden sm:flex items-center gap-4 md:gap-6">
              <span className="text-neutral-400">Selected Works</span>
              <span className="text-neutral-400">2020 — 2026</span>
            </div>

            <div className="flex items-center gap-4 md:gap-6">
              <span className="hidden md:inline text-neutral-400">
                Scroll / Drag to explore
              </span>
              <span className="flex items-center gap-2">
                Section
                <span className="text-neutral-900">02 / 06</span>
              </span>
            </div>
          </div>

          {/* Thin divider line — same width as the meta strip */}
          <div className="mt-3 md:mt-4 h-px w-full bg-gradient-to-r from-transparent via-neutral-200 to-transparent" />
        </div>

        {/* Ribbon Canvas — fills the remaining viewport height */}
        <div id="works" className="relative flex-1 w-full min-h-0">
          <RibbonGallery />
        </div>
      </section>
    </div>
  );
}